import React from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { registerSW } from 'virtual:pwa-register';
import App from './App.tsx';
import './index.css';
import { initGA4 } from './services/ga4';
import { initSentry } from './services/sentry';

// Initialize error monitoring (requires VITE_SENTRY_DSN env var)
initSentry();

// Initialize Google Analytics 4 (requires VITE_GA4_MEASUREMENT_ID env var)
initGA4();

// Register PWA service worker with auto-update
registerSW({
  onNeedRefresh() {
    // Auto-update when new content is available
    console.log('[PWA] New content available, updating...');
  },
  onOfflineReady() {
    console.log('[PWA] App ready for offline use');
  },
});

const container = document.getElementById('root');
if (!container) throw new Error('Root element not found');

createRoot(container).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<div className="p-8 text-center"><h1 className="text-xl font-bold mb-2">Something went wrong</h1><p>Please refresh the page or try again later.</p></div>}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
